import {SET_COMPANY_DATA} from "./types";

const initState = {
    formFilled: false,

    employeeCompanyNameId: '',
    employeeCompanyName: '',

    companyName: '',
    companyAddress: {
        address_components: {}
    },

    companyNameError: '',
    companyAddressError: '',

}

export const companyRegisterReducer = (state = initState, action) => {
    switch (action.type) {
        case SET_COMPANY_DATA:
            const {data} = action.payload
            if (action.payload.company) {
                let companyNameError = state.companyNameError || ''
                let companyAddressError = state.companyAddressError || ''


                if (data.companyName) {
                    if (data.companyName.length < 3) {
                        companyNameError = 'Tul rovid'
                    } else {
                        companyNameError = ''
                    }
                }

                if (data.companyAddress) {
                    if (data.companyAddress.address_components.length < 5) {
                        console.log('place sho')
                        companyAddressError = 'Telejes cimet'
                    } else {
                        companyAddressError = ''
                    }
                }


                return {
                    ...state,
                    ...action.payload.data,
                    companyNameError: companyNameError,
                    companyAddressError: companyAddressError,


                    /*companyName: action.payload.data.companyName || state.companyName || '',
                    companyAddress: action.payload.data.companyAddress || state.companyAddress || '',
                    formFilled: action.payload.data.formFilled || state.formFilled,*/
                }
            } else {
                /*let newState = {...state}
                Object.entries(action.payload.data).map(e=>{
                     newState[e[0]] = e[1]
                })
                return newState*/
                return {
                    ...state,
                    ...action.payload.data
                }

            }

        default:
            return state
    }
}